import { api } from "@/lib/api/client";
import type {
  SubmitRequest,
  ApproveRequest,
  RejectRequest,
  ForwardRequest,
  TextPublishRequest,
  TransferInitialRequest,
} from "@pkhoffice/shared";

export async function submitTextSign(data: SubmitRequest): Promise<{ textId: number }> {
  const res = await api.post("/text-sign/submit", data);
  return res.data.data ?? res.data;
}

export async function approveTextSign(id: number, data: ApproveRequest) {
  const res = await api.post(`/text-sign/${id}/approve`, data);
  return res.data.data ?? res.data;
}

export async function rejectTextSign(id: number, data: RejectRequest) {
  const res = await api.post(`/text-sign/${id}/reject`, data);
  return res.data.data ?? res.data;
}

export async function forwardTextSign(id: number, data: ForwardRequest) {
  const res = await api.post(`/text-sign/${id}/forward`, data);
  return res.data.data ?? res.data;
}

export async function transferInitialTextSign(id: number, data: TransferInitialRequest) {
  const res = await api.post(`/text-sign/${id}/transfer-initial`, data);
  return res.data.data ?? res.data;
}

export async function publishTextSign(id: number, data: TextPublishRequest) {
  const res = await api.post(`/text-sign/${id}/publish`, data);
  return res.data.data ?? res.data;
}

export async function recallTextSign(id: number) {
  const res = await api.post(`/text-sign/${id}/recall`, {});
  return res.data.data ?? res.data;
}

// #4279: số ký hiệu gợi ý để pre-fill hộp thoại ban hành (vẫn cho sửa).
export async function suggestRegisterNumber(id: number): Promise<{ suggested: string }> {
  const { data } = await api.get(`/text-sign/${id}/suggest-register-number`);
  return (data.data ?? data) as { suggested: string };
}

export async function fetchSigners(params: { role?: number; orgId?: number; q?: string } = {}) {
  const { data } = await api.get("/text-sign/signers", { params });
  return (data.data ?? data) as { staffId: number; loginName: string; fullName: string }[];
}

export async function fetchTextTypes() {
  const { data } = await api.get("/text-sign/types");
  return (data.data ?? data) as { typeId: number; name: string | null }[];
}
